// import React, { useState } from 'react';
// import { AppBar, Toolbar, Typography, Button, IconButton, Avatar, Menu, MenuItem, Tooltip, useMediaQuery } from '@mui/material';
// import { Link, useLocation, useNavigate } from 'react-router-dom';
// import MenuIcon from '@mui/icons-material/Menu';
// import { useTheme } from '@mui/material/styles';

// function TaskBar({ username, profilePhoto, onLogout }) {
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [menuOpen, setMenuOpen] = useState(false); // Hamburger menu for mobile
//   const location = useLocation();
//   const navigate = useNavigate();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

//   const handleMenuOpen = (e) => setAnchorEl(e.currentTarget);
//   const handleMenuClose = () => setAnchorEl(null);
//   const handleLogoutClick = () => {
//     handleMenuClose();
//     onLogout();
//   };
//   const handlePrivateChatClick = () => {
//     if (isMobile) setMenuOpen(false);
//     navigate('/private/select');
//   };
//   const handleHamburgerMenu = (e) => setMenuOpen(e.currentTarget);
//   const handleHamburgerClose = () => setMenuOpen(false);

//   // Generate avatar source
//   const avatarSrc = (() => {
//     if (!profilePhoto) return undefined;
//     if (profilePhoto.startsWith('http')) return profilePhoto;
//     return `http://localhost:5000/${profilePhoto.replace(/^\/+/, '')}`;
//   })();

//   // Menu items for navigation
//   const navItems = [
//     { label: 'Home', to: '/' },
//     { label: 'Global Chat', to: '/group' },
//     { label: 'Groups', to: '/groups' },
//     { label: 'Private Chat', to: '/private/select', onClick: handlePrivateChatClick },
//     { label: 'Profile', to: '/profile' },
//     { label: 'Settings', to: '/settings' },
//   ];

//   return (
//     <AppBar position="fixed" sx={{
//       bgcolor: '#121212',
//       zIndex: 1300,
//       boxShadow: '0 3px 15px rgba(111,66,193,0.8)'
//     }}>
//       <Toolbar sx={{
//         maxWidth: 1200,
//         mx: 'auto',
//         width: '100%',
//         minHeight: isMobile ? 54 : 64,
//         px: isMobile ? 1 : 2
//       }}>
//         {isMobile ? (
//           <>
//             <IconButton edge="start" color="inherit" aria-label="menu" onClick={handleHamburgerMenu} sx={{ mr: 1 }}>
//               <MenuIcon />
//             </IconButton>
//             <Menu
//               anchorEl={menuOpen}
//               open={Boolean(menuOpen)}
//               onClose={handleHamburgerClose}
//               anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
//               transformOrigin={{ vertical: 'top', horizontal: 'left' }}
//             >
//               {navItems.map((item) => (
//                 <MenuItem
//                   key={item.label}
//                   component={Link}
//                   to={item.to}
//                   onClick={item.onClick ? item.onClick : handleHamburgerClose}
//                   selected={location.pathname === item.to}
//                 >
//                   {item.label}
//                 </MenuItem>
//               ))}
//               <MenuItem onClick={() => { handleHamburgerClose(); navigate('/profile'); }}>Profile</MenuItem>
//               <MenuItem onClick={handleLogoutClick}>Logout</MenuItem>
//             </Menu>
//             <Typography variant="h6" sx={{ flexGrow: 1, fontWeight: 'bold', letterSpacing: 1 }}>
//               YapZone
//             </Typography>
//           </>
//         ) : (
//           <>
//             <IconButton component={Link} to="/group" edge="start" color="inherit" aria-label="menu" sx={{ mr: 2 }}>
//               <MenuIcon />
//             </IconButton>
//             <Typography variant="h6" sx={{ flexGrow: 1, fontWeight: 'bold', letterSpacing: 1 }}>
//               YapZone
//             </Typography>
//             {navItems.map((item) => (
//               <Button
//                 key={item.label}
//                 component={Link}
//                 to={item.to}
//                 color="inherit"
//                 onClick={item.onClick}
//                 sx={{
//                   fontWeight: location.pathname === item.to ? 'bold' : 'normal',
//                   textDecoration: location.pathname === item.to ? 'underline' : 'none'
//                 }}
//               >
//                 {item.label}
//               </Button>
//             ))}
//           </>
//         )}
//         <Tooltip title={username}>
//           <IconButton color="inherit" onClick={handleMenuOpen} sx={{ ml: 1 }}>
//             <Avatar
//               src={avatarSrc}
//               sx={{
//                 bgcolor: '#7b5cf5',
//                 border: '2px solid #9562e2',
//                 width: isMobile ? 32 : 40,
//                 height: isMobile ? 32 : 40,
//                 fontSize: isMobile ? 18 : 24
//               }}
//             >
//               {!avatarSrc && username.charAt(0).toUpperCase()}
//             </Avatar>
//           </IconButton>
//         </Tooltip>
//         <Menu
//           anchorEl={anchorEl}
//           open={Boolean(anchorEl)}
//           onClose={handleMenuClose}
//           anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
//           transformOrigin={{ vertical: 'top', horizontal: 'right' }}
//           PaperProps={{
//             sx: {
//               bgcolor: '#1e1e2f',
//               color: '#c4befe',
//               borderRadius: 2,
//               mt: 1,
//               minWidth: 130,
//               boxShadow: '0 4px 12px #7c4bee'
//             },
//           }}
//         >
//           <MenuItem onClick={() => { handleMenuClose(); navigate('/profile'); }}>Profile</MenuItem>
//           <MenuItem onClick={handleLogoutClick}>Logout</MenuItem>
//         </Menu>
//       </Toolbar>
//     </AppBar>
//   );
// }

// export default TaskBar;


import React, { useState } from 'react';
import {
  AppBar, Toolbar, Typography, Avatar, Box, IconButton,
  Menu, MenuItem, Drawer, List, ListItem, ListItemButton,
  useMediaQuery, useTheme,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useNavigate, useLocation } from 'react-router-dom';

const API_BASE = process.env.REACT_APP_API_URL;

const getAvatarUrl = (photo) => {
  if (!photo) return undefined;
  if (photo.startsWith('http')) return photo;
  return `${API_BASE.replace(/\/+$/, '')}/${photo.replace(/^\/+/, '')}`;
};

const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'Global', path: '/group' },
  { label: 'Groups', path: '/groups' },
  { label: 'Private', path: '/private/select' },
  { label: 'Profile', path: '/profile' },
  { label: 'Settings', path: '/settings' },
];

export default function TaskBar({ username, profilePhoto, onLogout }) {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [anchorEl, setAnchorEl] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        bgcolor: '#0E1318',
        borderBottom: '1px solid #1A2228',
        zIndex: theme.zIndex.drawer + 1,
      }}
    >
      <Toolbar sx={{ px: { xs: 2, sm: 3 }, minHeight: '56px !important' }}>
        {/* Logo */}
        <Box
          sx={{ display: 'flex', alignItems: 'center', gap: 1.2, cursor: 'pointer', mr: 4 }}
          onClick={() => navigate('/')}
        >
          <Box sx={{
            width: 28, height: 28, borderRadius: '7px',
            bgcolor: '#00C2B3', display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <svg width="14" height="14" viewBox="0 0 22 22" fill="none">
              <path d="M3 6C3 4.9 3.9 4 5 4H17C18.1 4 19 4.9 19 6V13C19 14.1 18.1 15 17 15H12L8 19V15H5C3.9 15 3 14.1 3 13V6Z" fill="#090C0F"/>
            </svg>
          </Box>
          <Typography sx={{
            fontFamily: "'Outfit', sans-serif", fontWeight: 700, fontSize: 17, color: '#F0F4F8',
          }}>
            YapZone
          </Typography>
        </Box>

        {/* Desktop nav */}
        {!isMobile && (
          <Box sx={{ display: 'flex', gap: 0.5, flex: 1 }}>
            {navLinks.map(link => (
              <Box
                key={link.path}
                onClick={() => navigate(link.path)}
                sx={{
                  px: 1.5, py: 0.7, borderRadius: '8px', cursor: 'pointer',
                  bgcolor: location.pathname === link.path ? '#0E2020' : 'transparent',
                  border: `1px solid ${location.pathname === link.path ? '#0A3530' : 'transparent'}`,
                  '&:hover': { bgcolor: '#111820' },
                }}
              >
                <Typography sx={{
                  fontFamily: "'Outfit', sans-serif", fontSize: 13,
                  color: location.pathname === link.path ? '#00C2B3' : '#5A6A78',
                  fontWeight: location.pathname === link.path ? 600 : 400,
                }}>
                  {link.label}
                </Typography>
              </Box>
            ))}
          </Box>
        )}

        <Box sx={{ flex: isMobile ? 1 : 'unset' }} />

        {/* Avatar / profile menu */}
        <IconButton
          onClick={e => setAnchorEl(e.currentTarget)}
          sx={{ p: 0.5, ml: 1 }}
        >
          <Avatar
            src={getAvatarUrl(profilePhoto)}
            sx={{ width: 32, height: 32, bgcolor: '#00C2B3', fontSize: 12, fontWeight: 700, color: '#090C0F' }}
          >
            {!profilePhoto && username?.[0]?.toUpperCase()}
          </Avatar>
        </IconButton>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
          PaperProps={{
            sx: {
              bgcolor: '#0E1318', border: '1px solid #1A2228',
              borderRadius: '12px', mt: 1, minWidth: 160,
            }
          }}
        >
          {[
            { label: 'Profile', path: '/profile' },
            { label: 'Settings', path: '/settings' },
          ].map(item => (
            <MenuItem
              key={item.path}
              onClick={() => { navigate(item.path); setAnchorEl(null); }}
              sx={{
                fontFamily: "'Outfit', sans-serif", fontSize: 14, color: '#A0B0BF',
                '&:hover': { bgcolor: '#111820', color: '#F0F4F8' },
              }}
            >
              {item.label}
            </MenuItem>
          ))}
          <MenuItem
            onClick={() => { onLogout(); setAnchorEl(null); }}
            sx={{
              fontFamily: "'Outfit', sans-serif", fontSize: 14, color: '#FF6B6B',
              borderTop: '1px solid #1A2228', mt: 0.5,
              '&:hover': { bgcolor: '#1A0E0E' },
            }}
          >
            Sign out
          </MenuItem>
        </Menu>

        {/* Mobile hamburger */}
        {isMobile && (
          <IconButton onClick={() => setDrawerOpen(true)} sx={{ color: '#5A6A78', ml: 0.5 }}>
            <MenuIcon />
          </IconButton>
        )}
      </Toolbar>

      {/* Mobile drawer */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{ sx: { bgcolor: '#0E1318', borderLeft: '1px solid #1A2228', width: 220 } }}
      >
        <Box sx={{ pt: 2, px: 1.5 }}>
          {navLinks.map(link => (
            <ListItemButton
              key={link.path}
              onClick={() => { navigate(link.path); setDrawerOpen(false); }}
              sx={{
                borderRadius: '10px', mb: 0.5,
                bgcolor: location.pathname === link.path ? '#0E2020' : 'transparent',
                '&:hover': { bgcolor: '#111820' },
              }}
            >
              <Typography sx={{
                fontFamily: "'Outfit', sans-serif", fontSize: 14,
                color: location.pathname === link.path ? '#00C2B3' : '#A0B0BF',
                fontWeight: location.pathname === link.path ? 600 : 400,
              }}>
                {link.label}
              </Typography>
            </ListItemButton>
          ))}
          <ListItemButton
            onClick={() => { onLogout(); setDrawerOpen(false); }}
            sx={{ borderRadius: '10px', mt: 2, '&:hover': { bgcolor: '#1A0E0E' } }}
          >
            <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 14, color: '#FF6B6B' }}>
              Sign out
            </Typography>
          </ListItemButton>
        </Box>
      </Drawer>
    </AppBar>
  );
}